<template>
    <div class="game-info-switch" @click="switchStatus">
        <div class="switch-info"></div>
        <div class="switch-text">
            <p>{{ status ? switchDesc : desc }}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        desc: {
            type: String,
            default: '切換至滿級滿潛'
        },
        switchDesc: {
            type: String,
            default: '切換至初始數據'
        },
        status: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        switchStatus() {
            this.$emit('switch', !this.status)
        }
    }
}
</script>

<style scoped lang="scss">
.game-info-switch {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    cursor: pointer;

    .switch-text {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: .01rem;

        p {
            font-size: .22rem;
        }
    }
}
</style>